<template>
  <v-container>
    <!-- <RegisterForm /> -->
    <RegisterList />
  </v-container>
</template>

<script>
// import RegisterForm from "@/components/register/RegisterForm.vue";
import RegisterList from "@/components/register/RegisterList.vue";
export default {
  name: "RegisterPage",
  components: {
    // RegisterForm,
    RegisterList,
  },
  data: () => ({
    // valid: true,
    // loading: false,
    // rules: {
    //   required: (v) => !!v || "Name is required",
    // },
  }),
};
</script>